import CRUDActions from './CRUD';
import Participant from '../api/participant';

class ParticipantCRUDActions extends CRUDActions {
  prefix = 'participant';

  get _model() {
    return Participant;
  }
}


export default new ParticipantCRUDActions();



// WEBPACK FOOTER //
// ./src/actions/participant.js